<template>
<div id="houses">
  <svg width="100%" height="100%" viewBox="0 0 401 401" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">
    <rect :stroke="getTheme.fore" x="0.5" y="0.5" width="400" height="400" style="fill:none;stroke-width:1px;"/>
    <path :stroke="getTheme.fore" d="M200.5,0.5l200,200l-200,200l-200,-200l200,-200Z" style="fill:none;stroke-width:1px;"/>
    <path :stroke="getTheme.fore" d="M0.5,0.5l100,100" style="fill:none;stroke-width:1px;"/>
    <path :stroke="getTheme.fore" d="M400.5,0.5l-100,100" style="fill:none;stroke-width:1px;"/>
    <path :stroke="getTheme.fore" d="M400.5,400.5l-100,-100" style="fill:none;stroke-width:1px;"/>
    <path :stroke="getTheme.fore" d="M0.5,400.5l100,-100" style="fill:none;stroke-width:1px;"/>
    <rect :stroke="getTheme.fore" x="100.5" y="100.5" width="200" height="200" style="fill:none;stroke-width:1px;"/>
  </svg>
  <div id="first" class="house">
    <Figure
      :figure-id="1"
      is-house
      is-editable
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="first-sign" class="house">
    <Zodiac :name="getSign(1)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="first-planet" class="house">
    <Planet :name="getPlanet(1)" :color="getColor(1)" :size="planetSize" />
  </div>
  <div id="first-label" class="house">I</div>

  <div id="second" class="house">
    <Figure
      :figure-id="2"
      is-house
      is-editable
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="second-sign" class="house">
    <Zodiac :name="getSign(2)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="second-planet" class="house">
    <Planet :name="getPlanet(2)" :color="getColor(2)" :size="planetSize" />
  </div>
  <div id="second-label" class="house">II</div>

  <div id="third" class="house">
    <Figure
      :figure-id="3"
      is-house
      is-editable
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="third-sign" class="house">
    <Zodiac :name="getSign(3)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="third-planet" class="house">
    <Planet :name="getPlanet(3)" :color="getColor(3)" :size="planetSize" />
  </div>
  <div id="third-label" class="house">III</div>

  <div id="fourth" class="house">
    <Figure
      :figure-id="4"
      is-house
      is-editable
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="fourth-sign" class="house">
    <Zodiac :name="getSign(4)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="fourth-planet" class="house">
    <Planet :name="getPlanet(4)" :color="getColor(4)" :size="planetSize" />
  </div>
  <div id="fourth-label" class="house">IV</div>

  <div id="fifth" class="house">
    <Figure
      :figure-id="5"
      is-house
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="fifth-sign" class="house">
    <Zodiac :name="getSign(5)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="fifth-planet" class="house">
    <Planet :name="getPlanet(5)" :color="getColor(5)" :size="planetSize" />
  </div>
  <div id="fifth-label" class="house">V</div>

  <div id="sixth" class="house">
    <Figure
      :figure-id="6"
      is-house
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="sixth-sign" class="house">
    <Zodiac :name="getSign(6)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="sixth-planet" class="house">
    <Planet :name="getPlanet(6)" :color="getColor(6)" :size="planetSize" />
  </div>
  <div id="sixth-label" class="house">VI</div>

  <div id="seventh" class="house">
    <Figure
      :figure-id="7"
      is-house
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="seventh-sign" class="house">
    <Zodiac :name="getSign(7)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="seventh-planet" class="house">
    <Planet :name="getPlanet(7)" :color="getColor(7)" :size="planetSize" />
  </div>
  <div id="seventh-label" class="house">VII</div>

  <div id="eighth" class="house">
    <Figure
      :figure-id="8"
      is-house
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="eighth-sign" class="house">
    <Zodiac :name="getSign(8)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="eighth-planet" class="house">
    <Planet :name="getPlanet(8)" :color="getColor(8)" :size="planetSize" />
  </div>
  <div id="eighth-label" class="house">VIII</div>

  <div id="ninth" class="house">
    <Figure
      :figure-id="9"
      is-house
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="ninth-sign" class="house">
    <Zodiac :name="getSign(9)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="ninth-planet" class="house">
    <Planet :name="getPlanet(9)" :color="getColor(9)" :size="planetSize" />
  </div>
  <div id="ninth-label" class="house">IX</div>

  <div id="tenth" class="house">
    <Figure
      :figure-id="10"
      is-house
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="tenth-sign" class="house">
    <Zodiac :name="getSign(10)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="tenth-planet" class="house">
    <Planet :name="getPlanet(10)" :color="getColor(10)" :size="planetSize" />
  </div>
  <div id="tenth-label" class="house">X</div>

  <div id="eleventh" class="house">
    <Figure
      :figure-id="11"
      is-house
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="eleventh-sign" class="house">
    <Zodiac :name="getSign(11)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="eleventh-planet" class="house">
    <Planet :name="getPlanet(11)" :color="getColor(11)" :size="planetSize" />
  </div>
  <div id="eleventh-label" class="house">XI</div>

  <div id="twelfth" class="house">
    <Figure
      :figure-id="12"
      is-house
      is-borderless
    />
  </div>
  <div v-if="showSigns" id="twelfth-sign" class="house">
    <Zodiac :name="getSign(12)" :color="getTheme.fore" :size="signSize"/>
  </div>
  <div v-if="showSigns" id="twelfth-planet" class="house">
    <Planet :name="getPlanet(12)" :color="getColor(12)" :size="planetSize" />
  </div>
  <div id="twelfth-label" class="house">XII</div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Figure from './Figure.vue'
import Zodiac from './Zodiac'
import Planet from './Planet'

export default {
  name: 'Houses',
  components: {
    Figure,
    Zodiac,
    Planet
  },
  computed: {
    ...mapGetters(['getTheme', 'getSign', 'getPlanet', 'showSigns']),
    signSize () {
      return 18
    },
    planetSize () {
      return 16
    }
  },
  methods: {
    getColor (house) {
      if (`${house}` === this.$store.state.querentHouse) {
        return this.getTheme.primary
      }
      if (`${house}` === this.$store.state.quesitedHouse) {
        return this.getTheme.secondary
      }
      return this.getTheme.fore
    },
    switchSignsOn () {
      this.$store.commit('showSigns', { visible: true })
    },
    switchSignsOff () {
      this.$store.commit('showSigns', { visible: false })
    }
  }
}
</script>

<style lang="scss" scoped>
$width: 400px;
$height: 400px;

$side-offset-close: 10px;
$side-offset-far: 40px;

$hor-left: 75px;
$hor-mid: $hor-left + 100px;
$hor-right: $hor-left + 200px;

$ver-top: 50px;
$ver-mid: $ver-top + 100px;
$ver-bottom: $ver-top + 200px;

$top-offset: 6px;

#houses {
  width: $width;
  height: $height;
  position: relative;
}

.house {
  position: absolute;
}

#first {
  top: $ver-mid;
  left: $side-offset-far;
}
#first-sign {
  top: 190px;
  left: -22px;
}
#first-planet {
  top: 192px;
  left: 34px;
}
#first-label {
  top: 190px;
  left: 104px;
}

#second {
  top: $ver-bottom;
  left: $side-offset-close;
}
#second-sign {
  top: 290px;
  left: -22px;
}
#second-planet {
  top: 292px;
  left: 4px;
}
#second-label {
  top: 250px;
  left: 104px;
}

#third {
  top: $height - 100px + $top-offset;
  left: $hor-left;
}
#third-sign {
  top: 403px;
  left: 92px;
}
#third-planet {
  top: 348px;
  left: 70px;
}
#third-label {
  top: 280px;
  left: 130px;
}

#fourth {
  top: $height - 100px - $top-offset;
  left: $hor-mid;
}
#fourth-sign {
  top: 403px;
  left: 192px;
}
#fourth-planet {
  top: 336px;
  left: 170px;
}
#fourth-label {
  top: 280px;
  left: 193px;
}

#fifth {
  top: $height - 100px + $top-offset;
  left: $hor-right;
}
#fifth-sign {
  top: 403px;
  left: 292px;
}
#fifth-planet {
  top: 348px;
  left: 270px;
}
#fifth-label {
  top: 280px;
  left: 260px;
}

#sixth {
  top: $ver-bottom;
  right: $side-offset-close;
}
#sixth-sign {
  top: 290px;
  left: 402px;
}
#sixth-planet {
  top: 292px;
  left: 335px;
}
#sixth-label {
  top: 250px;
  left: 282px;
}

#seventh {
  top: $ver-mid;
  right: $side-offset-far;
}
#seventh-sign {
  top: 190px;
  left: 402px;
}
#seventh-planet {
  top: 192px;
  left: 306px;
}
#seventh-label {
  top: 190px;
  left: 278px;
}

#eighth {
  top: $ver-top;
  right: $side-offset-close;
}
#eighth-sign {
  top: 90px;
  left: 402px;
}
#eighth-planet {
  top: 92px;
  left: 335px;
}
#eighth-label {
  top: 130px;
  left: 274px;
}

#ninth {
  top: -$top-offset;
  left: $hor-right;
}
#ninth-sign {
  top: -22px;
  left: 290px;
}
#ninth-planet {
  top: 36px;
  left: 270px;
}
#ninth-label {
  top: 100px;
  left: 260px;
}

#tenth {
  top: $top-offset;
  left: $hor-mid;
}
#tenth-sign {
  top: -22px;
  left: 191px;
}
#tenth-planet {
  top: 48px;
  left: 171px;
}
#tenth-label {
  top: 100px;
  left: 196px;
}

#eleventh {
  top: -$top-offset;
  left: $hor-left;
}
#eleventh-sign {
  top: -22px;
  left: 91px;
}
#eleventh-planet {
  top: 36px;
  left: 71px;
}
#eleventh-label {
  top: 100px;
  left: 130px;
}

#twelfth {
  top: $ver-top;
  left: $side-offset-close;
}
#twelfth-sign {
  top: 90px;
  left: -22px;
}
#twelfth-planet {
  top: 92px;
  left: 4px;
}
#twelfth-label {
  top: 130px;
  left: 104px;
}
</style>
